export default __webpack_public_path__ + "static/media/analytics.5d7f81d1.svg";